@if (parts.length > 0) {
    @for (part of parts; track part; let index = $index) {
        <p>
            {{ 'X_SELLING_DIALOG.CABLE.DESCRIPTION' | translate: { name: part.name, sparePartId: part.id } }}
        </p>
        <div class="input-container">
            @if (!part.noCableDataAvailable) {
                <sew-button class="control-button" icon="minimize" hierarchy="tertiary" show-icon-only>
                    <button
                        (click)="decreaseCableSize(part)"
                        [attr.disabled]="
                            part.currentCableStepIndex === 0 ||
                            part.cableErrorType === CableErrorType.MINIMUM_EXCEEDED
                                ? true
                                : null
                        "
                    ></button>
                </sew-button>
            }
            <sew-input [status]="part.cableError ? 'error' : null">
                <label [for]="'cable-length-' + index">{{
                    'X_SELLING_DIALOG.CABLE.INPUT_LABEL' | translate
                }}</label>
                <input
                    [id]="'cable-length-' + index"
                    class="cable-length"
                    type="number"
                    [(ngModel)]="part.currentCableValue"
                    autocomplete="off"
                    (input)="inputValue(part)"
                />
                <div class="error-text">
                    {{
                        part.cableErrorMessageKey ?? ''
                            | translate
                                : {
                                      min: part.cableSteps[0],
                                      max: part.cableSteps[part.cableSteps.length - 1],
                                  }
                    }}
                </div>
            </sew-input>
            @if (!part.noCableDataAvailable) {
                <sew-button class="control-button" icon="plus" hierarchy="tertiary" show-icon-only>
                    <button
                        (click)="increaseCableSize(part)"
                        [attr.disabled]="
                            part.currentCableStepIndex === part.cableSteps.length - 1 ||
                            part.cableErrorType === CableErrorType.MAXIMUM_EXCEEDED
                                ? true
                                : null
                        "
                    ></button>
                </sew-button>
            }
        </div>
    }
} @else {
    <sew-skeleton class="skeleton-headline"></sew-skeleton>
    <sew-skeleton class="skeleton-input"></sew-skeleton>
}
